/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { SeedMessageSchemaContent } from './seedMessageSchemaContent';
import type { SeedMessageSchemaRole } from './seedMessageSchemaRole';
import type { SeedMessageSchemaUiPartsItem } from './seedMessageSchemaUiPartsItem';

export interface SeedMessageSchema {
  role: SeedMessageSchemaRole;
  content: SeedMessageSchemaContent;
  ui_parts?: SeedMessageSchemaUiPartsItem[];
}
